import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_6usanratk0: FaireBrandEntity = {
  token: "b_6usanratk0",
  type: "brand",
  name: "Thought Catalog",
  avatarUrl: "https://cdn.faire.com/fastly/122955d65bbb79894d92d61936cd6e503493e8d0106d73ee76ae97104c067bf0.png",
  bannerUrl: "https://cdn.faire.com/fastly/dcd8e99dc10487014d7769540c05ecef38e495f3c0df53917ad8c8f33fefa4ca.png",
  logoUrl: "https://cdn.faire.com/fastly/122955d65bbb79894d92d61936cd6e503493e8d0106d73ee76ae97104c067bf0.png",
  heroImageUrl: "https://cdn.faire.com/fastly/dcd8e99dc10487014d7769540c05ecef38e495f3c0df53917ad8c8f33fefa4ca.png",
  location: "New York, NY, USA",
  minimumOrderDollars: 0,
  rating: 5,
  reviewCount: 629,
  isTopShop: true,
  isInsider: true,
  description: "Thought Catalog brings together a community of creative minds to make beautiful products and reading experiences. Each item is carefully crafted and designed, and serves to inspire our minds and our surroundings. We strive to create optimal visual and textural experiences, making our products perfect for display and gifts. Our products support a broad community of authors and artists.\n",
  meta: {
    source: "api",
    importedAt: "2026-10-12T19:14:03.128Z",
    importedBy: "entity-db-cli"
  }
};
